import { render, staticRenderFns } from "./AppContentBlockImageCarousel.vue?vue&type=template&id=04f232a1&"
import script from "./AppContentBlockImageCarousel.vue?vue&type=script&lang=js&"
export * from "./AppContentBlockImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports